import { TIER_CODES, BLACK_DIAMOND_ROLE, DC_MANAGED_VIP_ROLE } from './loyalty.constants';
import { IUser } from '@gig/magic-sdk/dist/adapter/users/user';

const BLACK_DIAMOND_ROLES = [BLACK_DIAMOND_ROLE, DC_MANAGED_VIP_ROLE];

export function getTierCode(tierLevel: number) {
    switch (tierLevel) {
        case 0:
            return TIER_CODES.SILVER;
        case 1:
            return TIER_CODES.GOLD;
        case 2:
            return TIER_CODES.PLATINUM;
        case 3:
            return TIER_CODES.DIAMOND;
        case 4:
            return TIER_CODES.EMERALD;
        case 5:
            return TIER_CODES.RUBY;
        case 6:
            return TIER_CODES.BLACK_DIAMOND;
        default:
            return TIER_CODES.GOLD;
    }
}

export function isBlackDiamondUser(user: IUser | null): boolean {
    return BLACK_DIAMOND_ROLES.some((role) => user?.roles.includes(role));
}
